<template>
  <SettingsPageLayout v-if="loaded">
    <Header :task-name="taskName" @add-checklist="showNewModal = true" />
    <List
      :task-name="taskName"
      :checklists="onboardingChecklists"
      :setup-task-link="buildSetupTaskLink"
      @refresh="fetchOnboardingChecklists"
    />

    <UpsertModal
      form-kind="new"
      :task-name="taskName"
      :show-modal="showNewModal"
      @name-input="newChecklist.name = $event"
      @action="createChecklist"
      @close-modal="showNewModal = false"
    />
  </SettingsPageLayout>
</template>

<script>
import { Api } from '../../../api';
import SettingsPageLayout from '../../SettingsPageLayout/index.vue';
import Header from './ChecklistSettings/Header.vue';
import List from './ChecklistSettings/List.vue';
import UpsertModal from './ChecklistSettings/UpsertModal.vue';

const DEFAULT_NEW_CHECKLIST = {
  name: '',
  checklist_type: 'onboarding',
  primary_user_role: 'agent',
};

export default {
  components: {
    SettingsPageLayout,
    Header,
    UpsertModal,
    List,
  },
  data() {
    return {
      loaded: false,
      onboardingChecklists: [],
      showNewModal: false,
      newChecklist: {
        ...DEFAULT_NEW_CHECKLIST,
      },
      taskName: 'Onboarding',
    };
  },
  async mounted() {
    await this.fetchOnboardingChecklists();
    this.$store.commit('general/hideLocalLoadingSpinner');
  },
  methods: {
    async fetchOnboardingChecklists() {
      const { records } = await Api.TaskChecklists.listTaskChecklists({ type: 'onboarding' });
      this.onboardingChecklists = records;
      this.loaded = true;
    },
    async createChecklist() {
      try {
        await Api.TaskChecklists.createTaskChecklist(this.newChecklist);
        this.showNewModal = false;
        this.newChecklist = { ...DEFAULT_NEW_CHECKLIST };
        await this.fetchOnboardingChecklists();
      } catch (error) {
        console.error('Error creating checklist:', error);
      } finally {
        this.$store.commit('general/hideLocalLoadingSpinner');
      }
    },
    buildSetupTaskLink(checklistId) {
      return `/settings/company/onboarding_checklists/${checklistId}/edit`;
    },
  },
};
</script>
